export default __webpack_public_path__ + "static/media/settings.c93814d7.svg";